<template>
  <w-dialog :dialog-show="dialogState" :top="20" @handleClose="handleClose('close')">
    <template slot="content">
      <div class="content-container">

        <img class="image" src="https://files.wondercv.com/m-vue/campus/clock.png" alt="">

        <h3 class="title">关注提醒</h3>
        <p class="description">已关注「{{ companyName }}」<br />并为您自动创建网申待办事项</p>

        <button :class="{'active': clockFlag}" class="manage-btn btn" @click="handleClose('manage')">立即查看待办</button>

        <button v-if="!clockFlag" class="clock-btn btn">
          打开闹钟提醒
          <a href="https://mp.weixin.qq.com/s/FVcFkx7vGHYlVfPyo4cTJg"></a>
        </button>

        <div class="close-btn" @click="handleClose('close')">
          <i class="iconfont iconx"></i>
        </div>

      </div>
    </template>
  </w-dialog>
</template>

<script>
  import WDialog from '../../../components/global/w-dialog'
  export default {
    props: {
      companyName: {
        type: String,
        default: ''
      },
      clockFlag: {
        type: Boolean,
        default: false
      },
      dialogState: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return {
      }
    },
    mounted() {},
    components: {
      WDialog
    },
    watch: {
      companyName: {
        handler: (val) => {
          console.log('chenchenchen', val)
        }
      },
      dialogState: {
        handler: (val) => {
          console.log('dialogState', val)
        }
      }
    },
    computed: {},
    methods: {
      handleClose(type) {
        this.$emit(type === 'close' ? 'handleClose' : 'toCampusManage')
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../../assets/scss/global/variable';
  .content-container {
    box-shadow: 0 2px 8px 0 rgba($color: #000000, $alpha: .39);
    width: calc(100vw - 64px);
    border-radius: 12px;
    padding: 26px 0 36px;
    background-color: $color-light;
    display: flex;
    flex-direction: column;
    align-items: center;

    .image {
      width: 61%;
      margin-bottom: 22px;
    }

    .title {
      font-size: 18px;
      font-weight: 600;
      color: #404040;
      line-height: 18px;
      margin-bottom: 14px;
    }

    .description {
      font-size: 14px;
      font-weight: 400;
      color: #9C9C9C;
      line-height: 22px;
      margin-bottom: 20px;
      text-align: center;
    }

    .btn {
      width: 61%;
      height: 40px;
      line-height: 22px;
      font-size: 16px;
      font-weight: 400;
      border-radius: 23px;
      box-sizing: border-box;
      border: none;

      &.manage-btn {
        color: #FF6644;
        border: 1px solid #FF6644;
        background: #ffffff;

        &.active {
          border: none;
          color: #FFFFFF;
          background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
        }
      }

      &.clock-btn {
        position: relative;
        margin-top: 14px;
        color: #FFFFFF;
        background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);

        >a {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }

    }

    .close-btn {
      position: absolute;
      bottom: -18%;
      left: 50%;
      transform: translateX(-50%);
      width: 35px;
      height: 35px;
      border: 3px solid #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      >i {
        color: #fff;
        font-size: 22px;
        font-weight: 900;
        margin-bottom: -2px;
      }
    }
  }
</style>
